import useReveal from "@/hooks/useReveal";

const quotes = [
  {
    body: "Your testimonial copy will live here. Replace with a real quote from a client describing the outcome you delivered.",
    name: "Client Name",
    role: "Founder, Brand Placeholder",
  },
  {
    body: "A second placeholder quote. Use this for a result-focused statement — revenue lifted, launch metrics, retention won.",
    name: "Client Name",
    role: "Creator, 280K Audience",
  },
  {
    body: "Third quote slot. Lean into specificity — names, numbers, before/after. Burgundy quotation marks do the rest.",
    name: "Client Name",
    role: "CEO, DTC Brand",
  },
];

export default function Testimonials() {
  const ref = useReveal();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      ref={ref}
      className="reveal relative px-6 md:px-12 py-28 md:py-40 bg-[#141414] border-t border-[#2E2A28]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16">
          <div className="col-span-12 md:col-span-7">
            <div className="overline section-mark mb-6">Said Quietly</div>
            <h2 className="font-serif-display text-4xl md:text-6xl font-light leading-[1] tracking-tight text-[#F2E7DF]">
              In their <span className="italic text-[#E5C16C]">own words.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2E2A28] border border-[#2E2A28]">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#141414] p-10 md:p-12 transition-colors duration-500 hover:bg-[#181818] flex flex-col justify-between"
            >
              <span
                className="font-serif-display text-7xl text-[#E5C16C] leading-none -mb-4"
                aria-hidden="true"
              >
                &ldquo;
              </span>
              <blockquote className="font-serif-display italic text-xl md:text-2xl text-[#F2E7DF] font-light leading-snug">
                {q.body}
              </blockquote>
              <figcaption className="mt-10 pt-6 border-t border-[#2E2A28]">
                <div className="font-mono-detail text-xs tracking-[0.18em] uppercase text-[#F2E7DF]">
                  {q.name}
                </div>
                <div className="font-mono-detail text-[0.65rem] tracking-[0.22em] uppercase text-[#A19D9B] mt-1">
                  {q.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
